'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');

var _RealtorLandingContactFormComponent = require('./RealtorLandingContactFormComponent');var _RealtorLandingContactFormComponent2 = _interopRequireDefault(_RealtorLandingContactFormComponent);


var _contactUs = require('../../redux/modules/contactUs');
var _messageModal = require('../../redux/modules/messageModal');

var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    userData: state.userAuthentication.data,
    contactUs: state.contactUs,
    isMessageModalOpen: state.messageModal.isMessageModalOpen };};exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, {
  sendContactUsForm: _contactUs.sendContactUsForm,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal }),

(0, _reduxForm.reduxForm)({
  form: 'realtorLandingContactFormModal',
  validate: _validate2.default }))(_RealtorLandingContactFormComponent2.default);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorLandingContactForm/RealtorLandingContactFormModal.js
// module id = 3063
// module chunks = 0